
export default {
  locale: 'ru',
  dictionary: {
    ru: {
      attributes: {
        password: 'пароль',
        status: 'статус',
        role: 'роль',
        surname: 'фамилия',
        name: 'имя',
        patronymic: 'отчество',
        phone: 'телефон',
        name_role: 'название роли',
        company_name: 'название компании',
        inn: 'ИНН',
        kpp: 'КПП',
        ogrnin: 'ОГРНИП',
        ogrn: 'ОГРН',
        position: 'должность',
        act: 'действует на основании',
        city: 'город',
        worker_phone: 'рабочий телефон',
        mobile_phone: 'мобильный телефон',
        confirm_password: ' ',
        code: 'код',
        timetable: 'расписание',
        address: 'адрес'
      },
      messages: {
        _default : (field) => `The ${field} value is not valid.`,
        after : (field, [target]) => `The ${field} must be after ${target}.`,
        alpha_dash : (field) => `Поле ${field} должно содержать только цифры, буквы, - и _`,
        alpha_num : (field) => `Поле ${field} должно содержать только буквенно-цифровые символы.`,
        alpha_spaces : (field) => `The ${field} may only contain alphabetic characters as well as spaces.`,
        alpha : (field) => `The ${field} may only contain alphabetic characters.`,
        before : (field, [target]) => `The ${field} must be before ${target}.`,
        between : (field, [min, max]) => `The ${field} must be between ${min} and ${max}.`,
        confirmed : (field) => `Значение полей ${field} не совпадает.`,
        credit_card : (field) => `The ${field} is invalid.`,
        date_between : (field, [min, max]) => `The ${field} must be between ${min} and ${max}.`,
        date_format : (field, [format]) => `The ${field} must be in the format ${format}.`,
        decimal : (field) => `Поле ${field} обязательно для заполнения`,
        digits : (field, [length]) => `The ${field} must be numeric and exactly contain ${length} digits.`,
        dimensions : (field, [width, height]) => `The ${field} must be ${width} pixels by ${height} pixels.`,
        email : (field) => `Введите корректный ${field}.`,
        ext : (field) => `The ${field} must be a valid file.`,
        image : (field) => `The ${field} must be an image.`,
        in : (field) => `The ${field} must be a valid value.`,
        ip : (field) => `The ${field} must be a valid ip address.`,
        max : (field, [length]) => `Поле ${field} должно содержать не более ${length} символов.`,
        max_value : (field, [max]) => `The ${field} must be ${max} or less.`,
        mimes : (field) => `The ${field} must have a valid file type.`,
        min : (field, [length]) => `Поле ${field} должно содержать не менее ${length} символов.`,
        min_value : (field, [min]) => `The ${field} must be ${min} or more.`,
        not_in : (field) => `The ${field} must be a valid value.`,
        length : (field, [length]) => `Поле ${field} должно содержать ${length} символов`,
        regex : (field) => `The ${field} format is invalid.`,
        required : (field) => `Поле ${field} обязательно к заполнению.`,
        size : (field, [size]) => `The ${field} must be less than ${size} KB.`,
        url : (field) => `Поле ${field} не URL.`,
        integer : (field) => `Поле ${field} должно содержать только цифры.`
      }
    }
  }
}

